//Import named components
import { uiActions } from "./ui";
import { dealNoteActions } from "./deal-note";
import store from "./index";
import axios from "axios";

let ABORT_FETCH_CONTROLLER = null;

export const dealNotesAbortController = () => {
  return async (dispatch) => {
    ABORT_FETCH_CONTROLLER.abort();
  };
};

export const fetchDealNotes = (dealId) => {
  ABORT_FETCH_CONTROLLER = new AbortController();

  const token = store.getState().userReducer.token;
  return async (dispatch) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/deal-notes/deals/${dealId}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
          signal: ABORT_FETCH_CONTROLLER.signal,
        }
      );

      const responseData = await response.data;

      dispatch(dealNoteActions.replaceNoteData({ notes: responseData.notes }));

    } catch (error) {
      if (axios.isCancel(error)) {
      } else {
        dispatch(
          uiActions.showNotification({
            status: "error",
            title: "Error",
            message: error.message || "Something went wrong, please try again.",
          })
        );
      }
    }
  };
};

export const createDealNote = (noteData) => {
  const token = store.getState().userReducer.token;
  return async (dispatch) => {
    //set event loading to true
    dispatch(dealNoteActions.setIsNoteLoading(true));
    try {
      const formData = new FormData();
      formData.append("text", noteData.text);
      if (noteData.file) {
        noteData.file.forEach((file) => {
          formData.append("file", file);
        });
      }
      formData.append("belongsTo", noteData.belongsTo);
      formData.append("creator", noteData.creator);

      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/deal-notes`,
        formData,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
          onUploadProgress: (data) => {
            const progress = Math.round((100 * data.loaded) / data.total);

            if (progress > 0) {
              dispatch(
                dealNoteActions.setUploadProgress(
                  Math.round((100 * data.loaded) / data.total)
                )
              );
            }
            if (progress === 100) {
              dispatch(dealNoteActions.setUploadProgress(0));
            }
          },
        }
      );

      dispatch(dealNoteActions.addNote({ note: response.data.note }));

      //set note loading to false
      dispatch(dealNoteActions.setIsNoteLoading(false));
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error",
          message: error.message || "Something went wrong, please try again.",
        })
      );
    }
  };
};

export const updateNote = (noteData) => {
  const token = store.getState().userReducer.token;
  return async (dispatch) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/deal-notes/${noteData.noteId}`,
        {
          method: "PATCH",
          body: JSON.stringify({
            id: noteData.noteId,
            text: noteData.text,
            creator: noteData.creator,
            belongsTo: noteData.belongsTo,
          }),
          headers: {
            "content-type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );

      const responseData = await response.json();

      //dispatch to store
      dispatch(dealNoteActions.updateNote(responseData.note));
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error",
          message: error.message || "Something went wrong, please try again.",
        })
      );
    }
  };
};

export const deleteNote = (noteData) => {
  const token = store.getState().userReducer.token;
  return async (dispatch) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/deal-notes/${noteData.noteId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      const responseData = await response.json();

      //dispatch to store
      dispatch(dealNoteActions.deleteNote(noteData.noteId));
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error",
          message: error.message || "Something went wrong, please try again.",
        })
      );
    }
  };
};
